import React, {useContext} from "react"

import TranslationContext from "../../../context/TranslationContext";

const Button = ({onClick, idPhrase, description, disabled = false}) => {
    // debugger
    const { getTranslation } = useContext(TranslationContext)

    return <button
        className="btn element-border"
        disabled={disabled}
        onClick={onClick}
    >
        <span data-id_phrase={idPhrase} >{getTranslation(idPhrase) === "" ? description : getTranslation(idPhrase)}</span>
    </button>
}

export default Button